import * as React from "react";
import { api } from "./api";

export const vars = {
};

// helpers
export const __ = (path, strlen = 0) => {
    // https://www.charactercountonline.com/
    const rep = ''.padStart(strlen, `${path} `);
    const t = window['CONFIG'].texts[path];
    if (t) { return (<span dangerouslySetInnerHTML={{__html: t}} ></span>); }
    return (strlen > 0) ? rep : path;
}

export const __BETA = window['CONFIG'].beta;
export const __TRIAL_DATE = window['CONFIG'].trial_date;

export const classNames = (...args: (string | null)[]) => {
    return args.filter(v => v != null).join(" ");
};

export const asset = (path) => {
    return `/static/${path}`;
}


// WEBPACK FOOTER //
// ./src/services/theme.tsx